import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import api from "@/lib/api";
import { Printer } from "@phosphor-icons/react";

const PrintCheckpoints = () => {
  const { siteId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/sites/${siteId}/checkpoints/print`)
      .then(({ data }) => setData(data))
      .catch((e) => setError(e?.response?.data?.detail || "Failed to load"));
  }, [siteId]);

  if (error) return <div className="p-10 text-center text-red-500">{error}</div>;
  if (!data) return <div className="p-10 text-center text-zinc-500 label-mono">LOADING...</div>;

  return (
    <div className="min-h-screen bg-white text-black p-8 print:p-0" data-testid="print-checkpoints-page">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          .qr-card { page-break-inside: avoid; break-inside: avoid; border: 2px solid #000 !important; }
        }
      `}</style>

      <div className="max-w-4xl mx-auto">
        <div className="no-print flex items-center justify-between mb-6 pb-4 border-b border-gray-300">
          <div>
            <div className="text-xs uppercase tracking-wider text-gray-500">Sandy · Checkpoint QR sheet</div>
            <h1 className="text-2xl font-bold">{data.site.name}</h1>
            <div className="text-sm text-gray-600">{data.site.address}</div>
          </div>
          <button
            data-testid="print-btn"
            onClick={() => window.print()}
            className="flex items-center gap-2 bg-black text-white px-4 py-2 text-sm font-semibold hover:bg-gray-800"
          >
            <Printer size={14}/> Print sheet
          </button>
        </div>

        {data.checkpoints.length === 0 ? (
          <div className="text-center py-20 text-gray-500">
            No checkpoints yet for this site. Add some from the Sites page.
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-6">
            {data.checkpoints.map((cp, i) => (
              <div key={cp.checkpoint_id} className="qr-card border-2 border-black p-6 text-center" data-testid={`qr-card-${cp.checkpoint_id}`}>
                <div className="text-[10px] uppercase tracking-widest text-gray-500 mb-1">Sandy Checkpoint · {String(i + 1).padStart(2, "0")}</div>
                <div className="text-2xl font-black uppercase mb-4">{cp.name}</div>
                <div className="bg-white p-3 inline-block border border-gray-300">
                  <QRCodeSVG value={cp.url} size={200} level="H" includeMargin={false}/>
                </div>
                <div className="text-[9px] text-gray-500 mt-3 font-mono break-all">{cp.url}</div>
                <div className="text-xs mt-3 font-semibold">{data.site.name}</div>
                <div className="text-[10px] text-gray-500">Scan with phone camera</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PrintCheckpoints;
